











































import {
  Component, Vue, Watch, Prop,
} from 'vue-property-decorator';

@Component
export default class ConfirmLeaveDialog extends Vue {
  @Prop({ type: Boolean, default: false }) persistent;

  active: boolean = false;

  header: string = '';

  body: string = '';

  preFooter: string = '';

  footer: string = '';


  answer: Function = () => false;

  pop(header: string, body: string, preFooter: string, footer: string): Promise<boolean> {
    this.header = header;
    this.body = body;
    this.preFooter = preFooter;
    this.footer = footer;
    this.active = true;

    return new Promise((resolve: Function, reject: Function) => {
      this.answer = resolve;
    });
  }

  @Watch('active')
  onDialogStateChanging() {
    if (!this.active) {
      this.answer(false);
    }
  }

  continueTo(): void {
    this.active = false;
    this.answer(true);
  }
}
